import { ArticleSection } from './ArticleSection';
import { DialogSection } from './DialogSection';
import { MediaSection } from './MediaSection';
import { PdfSection } from './PdfSection';
import { QuestionSection } from './QuestionSection';
import { Section } from './Section';
import { VocabSection } from './VocabSection';

export default [
  Section,
  DialogSection,
  MediaSection,
  QuestionSection,
  VocabSection,
  ArticleSection,
  PdfSection,
];
